import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OAuthenticationService } from 'src/app/shared/authentication/oauthentication.service';

export const AuthenticationGuard = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const authService = inject(OAuthenticationService);
  const router = inject(Router);

  try {
    const isAuthorized = await authService.isAuthenticatedOrRefresh();

    if (!isAuthorized) {
      return router.createUrlTree(['/Login'], {
        queryParams: { returnUrl: state.url },
      });
    }

    return true;
  } catch (error) {
    console.error('Error refreshing token on guard', error);
    return router.createUrlTree(['/Login'], {
      queryParams: { returnUrl: state.url },
    });
  } finally {
    //
  }
};
